import React, { useEffect, useState } from 'react'
import { Button, Tooltip, IconButton, makeStyles } from '@material-ui/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { ContentCopy, Done } from '@material-ui/icons'

const CopyButton = ({ name, value, type, tooltip }) => {
  const classes = useStyles()
  const [copiedValue, setCopiedValue] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copiedValue) setCopiedValue(false)
    }, 2000)

    return () => clearTimeout(timeout)
  }, [copiedValue])
  return (
    <CopyToClipboard text={value} onCopy={() => setCopiedValue(true)}>
      {type !== 'icon' ? (
        <Button
          className={classes.btn}
          startIcon={copiedValue ? <Done /> : <ContentCopy />}
          size="small"
          variant="contained">
          {copiedValue ? 'Copied' : name}
        </Button>
      ) : (
        <Tooltip title={copiedValue ? 'Copied' : tooltip}>
          <IconButton className={classes.iconBtn}>
            {copiedValue ? <Done /> : <ContentCopy />}
          </IconButton>
        </Tooltip>
      )}
    </CopyToClipboard>
  )
}

export default CopyButton

const useStyles = makeStyles({
  btn: {
    fontWeight: 'bold',
    textTransform: 'none'
  },
  iconBtn: {
    padding: '8px'
  }
})
